<template>
	<div class="exchangeRecord-user" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.forrecord") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>
		<ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
			<div class="exchangeRecord-main">
				<div v-if="convertRecordslist.length < 1" style="padding:  3rem 0;color: #ffffff;text-align: center;">
					{{ $t("transactiondetails.not") }}
				</div>
				<div v-else class="card" v-for="(item, index) in convertRecordslist" :key="index">
					<div class="card-top">{{ item.createTime }}</div>
					<div class="card-center">
						<p>{{ item.consumeNumber }}{{ item.consumeCoin }}</p>
						<p>+{{ item.getNumber }}{{ item.getCoin }}</p>
					</div>
					<div class="card-bottom">{{ $t("forrecord.spending") }}</div>
				</div>
			</div>
		</ul>
	</div>
</template>

<script>
import {
	convertRecords,
	convert
} from "@/utils/request";
export default {
	data() {
		return {
			current: 1,
			size: 10,
			lucky: 1,
			convertRecordslist: [],
			USDTnumber: '',
			TRXnumber: '',
			height: '',//屏幕高度
		};
	},
	//获取屏幕高度
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() {
		this.convertRecords()
	},
	methods: {
		load() {
			var that = this
			convertRecords({
				current: that.current + 1,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					if (res.data.records.length > 0) {
						that.current += 1
						that.convertRecordslist = [...this.convertRecordslist, ...res.data.records]
					}
				}
			});
		},
		convert() {
			var that = this
			convert({
				txHash: "",
				consumeCoin: "USDT",
				consumeNumber: that.USDTnumber,
				getCoin: "TRX",
				getNumber: that.TRXnumber
			}).then((res) => {
				if (res.code == "200") {
					console.log(res)
				}
			});
		},
		convertRecords() {
			var that = this
			convertRecords({
				current: that.current,
				size: that.size,
			}).then((res) => {
				if (res.code == "200") {
					that.convertRecordslist = res.data.records
				}
			});
		},
		toBack() {
			this.$router.push("/user");
		},
	},
};
</script>

<style lang="scss" scoped>
.infinite-list {
	height: calc(var(--height) - 15.25rem);
}

.Warm-prompt {
	margin-top: 0.9375rem;

	img {
		width: 0.9375rem;
		height: 0.9375rem;
	}

	span {
		font-size: 0.75rem;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}
}

.money {
	// height: 292px;
	border-radius: 0.625rem;
	opacity: 1;
	margin-top: 1.25rem;
	padding: 0.9375rem;
	border: 0.0625rem solid #272727;

	.Immediatelychange {
		margin-top: 1.875rem;

		button {
			font-size: 0.9375rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #0C0B0B;
			height: 2.6875rem;
			background: linear-gradient(180deg, #FFDB67 0%, #F8C007 100%);
			border-radius: 1.375rem;
			opacity: 1;
			width: 100%;
		}

	}

	.moneyaddress {
		font-size: 0.75rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
		margin-top: 0.9375rem;
	}

	.img-zh {
		text-align: center;
		height: 2.3125rem;
		line-height: 4.8125rem;

		img {
			width: 0.9375rem;
			height: 1.3125rem;
		}
	}

	.input-exchange {
		background: #161414;
		border-radius: 0.25rem;
		opacity: 1;
		display: flex;
		justify-content: space-between;
		padding: 0.5rem 0.625rem;
		line-height: 1.5rem;
		margin-top: 0.9375rem;

		input {
			background: none;
			color: #999999;
		}

		img {
			width: 1.6875rem;
			height: 1.6875rem;
		}

		div:nth-child(1) {
			span {
				font-size: 0.8125rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #555555;
			}
		}

		div:nth-child(2) {
			display: flex;

			span {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				margin-top: 0.1875rem;
				margin-left: 0.3125rem;
			}
		}
	}

	.exchange {
		span:nth-child(1) {
			font-size: 0.875rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
		}

		span:nth-child(2) {
			margin-left: 0.625rem;
			font-size: 0.75rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FF693A;
		}
	}
}

.lucky {
	// height: 39px;
	display: flex;
	justify-content: space-around;
	padding-top: 1.0625rem;

	div {
		width: auto;
		height: 1.4375rem;
	}

	.click-div {
		span {
			font-size: 1rem;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #f8c007;
		}

		width: auto;
		border-bottom: 0.0625rem solid #f8c007;
		height: 1.4375rem;
	}

	span {
		width: 5rem;
		height: 1.4375rem;
		font-size: 1rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #999999;
	}
}

.exchangeRecord-user {
	width: 100vw;
	height: var(--height);
	background: #0c0b0b;

	.exchangeRecord-main {
		padding: 0 0.9375rem;

		.card {
			width: 100%;
			background: #161414;
			border-radius: 0.625rem;
			margin-bottom: .9375rem;

			.card-top {
				font-size: 0.6875rem;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #999999;
				padding: 0.9375rem 0.9375rem 0.625rem;
			}

			.card-bottom {
				font-size: 0.75rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
				padding: 0 .9375rem .9375rem;
			}

			.card-center {
				display: flex;
				padding: 0 0.9375rem;
				justify-content: space-between;

				>p:nth-child(1) {
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #ffffff;
				}

				>p:nth-child(2) {
					font-size: 0.875rem;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 500;
					color: #d85158;
				}
			}
		}
	}

	.index-view-top {
		height: 3.625rem;
		padding: 0 0.9375rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.title {
			font-size: 1.125rem;
			font-family: PingFang SC-Bold, PingFang SC;
			font-weight: bold;
			color: #ffffff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/forrecord.vue